// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"3e25dcbf","239":"eb457756","455":"2438e75e","457":"f8e0b6e9","484":"bd5a7954","640":"e2648771","842":"2209c64a","851":"fe3c1a32","977":"22d04fff"}[chunkId] + ".chunk.js";
};